<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'PageBase',
}
</script>
<style scoped>

</style>
